/* BRUUT — minimal vanilla storefront behaviour */
(function () {
  'use strict';

  var routes = window.Shopify && window.Shopify.routes ? window.Shopify.routes : {};
  var ROOT = routes.root || '/';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function live(msg) {
    var el = document.getElementById('BruutLive');
    if (el) { el.textContent = ''; window.setTimeout(function () { el.textContent = msg; }, 60); }
  }
  function syncCount(n) {
    if (n == null) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = (String(n) === '0');
    });
  }

  /* ---------------- cart drawer ---------------- */
  var Drawer = {
    el: null,
    lastFocus: null,
    init: function () {
      this.el = document.getElementById('CartDrawer');
      if (!this.el) return;
      var self = this;
      this.el.addEventListener('click', function (e) {
        if (e.target.matches('[data-drawer-close], .drawer__scrim')) { e.preventDefault(); self.close(); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
        if (e.key === 'Tab' && self.el.classList.contains('is-open')) self.trap(e);
      });
      document.addEventListener('click', function (e) {
        var open = e.target.closest('[data-drawer-open]');
        if (open) { e.preventDefault(); self.open(); }
      });
    },
    focusables: function () {
      return Array.prototype.slice.call(this.el.querySelectorAll(
        'a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'
      )).filter(function (n) { return n.offsetParent !== null; });
    },
    trap: function (e) {
      var f = this.focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    },
    open: function () {
      if (!this.el) return;
      this.lastFocus = document.activeElement;
      this.el.classList.add('is-open');
      this.el.removeAttribute('aria-hidden');
      document.body.classList.add('drawer-open');
      var f = this.focusables();
      if (f.length) f[0].focus();
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      if (this.lastFocus) this.lastFocus.focus();
    },
    render: function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var next = parsed.getElementById('CartDrawer');
      if (!next || !this.el) return;
      var wasOpen = this.el.classList.contains('is-open');
      this.el.innerHTML = next.innerHTML;
      if (wasOpen) this.el.classList.add('is-open');
      var src = parsed.querySelector('[data-cart-count]');
      if (src) syncCount(src.textContent.trim());
    }
  };

  function refreshCart(openAfter) {
    return fetch(ROOT + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data['cart-drawer']) Drawer.render(data['cart-drawer']);
        return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        syncCount(cart.item_count);
        if (openAfter) Drawer.open();
        return cart;
      });
  }

  /* ---------------- add to cart ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-btn]');
    var label = btn ? btn.textContent : '';
    var err = form.querySelector('[data-form-error]');
    if (err) { err.textContent = ''; err.hidden = true; }
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = btn.dataset.loading || label; }

    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.json && res.json.description) || (res.json && res.json.message) || 'Er ging iets mis.';
          if (err) { err.textContent = msg; err.hidden = false; }
          live(msg);
          return;
        }
        if (res.json.sections && res.json.sections['cart-drawer']) {
          Drawer.render(res.json.sections['cart-drawer']);
          return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            syncCount(cart.item_count);
            Drawer.open(); live('Toegevoegd aan je winkelwagen.');
          });
        }
        return refreshCart(true).then(function () { live('Toegevoegd aan je winkelwagen.'); });
      })
      .catch(function () {
        if (err) { err.textContent = 'Verbinding mislukt. Probeer het opnieuw.'; err.hidden = false; }
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = label; }
      });
  });

  /* ---------------- cart line changes ---------------- */
  function changeLine(key, qty) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ id: key, quantity: qty, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.sections && json.sections['cart-drawer']) Drawer.render(json.sections['cart-drawer']);
        syncCount(json.item_count);
        live(qty === 0 ? 'Verwijderd uit je winkelwagen.' : 'Winkelwagen bijgewerkt.');
      });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.dataset.lineRemove, 0); return; }

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var input = step.parentElement.querySelector('input');
      if (!input) return;
      var min = parseInt(input.min || '1', 10);
      var v = parseInt(input.value || '1', 10) + parseInt(step.dataset.qtyStep, 10);
      if (isNaN(v) || v < min) v = min;
      input.value = v;
      if (input.dataset.lineKey) changeLine(input.dataset.lineKey, v);
      else input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('input[data-line-key]');
    if (!input) return;
    var v = parseInt(input.value || '1', 10);
    if (isNaN(v) || v < 0) v = 1;
    changeLine(input.dataset.lineKey, v);
  });

  /* ---------------- header shrink ---------------- */
  function header() {
    var el = document.querySelector('[data-header]');
    if (!el) return;
    var on = false;
    var onScroll = function () {
      var next = window.scrollY > 8;
      if (next !== on) { on = next; el.classList.toggle('is-scrolled', on); }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- mobile nav ---------------- */
  function mobileNav() {
    var nav = document.getElementById('MobileNav');
    if (!nav) return;
    var toggle = document.querySelector('[data-mnav-open]');
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      nav.classList.add('is-open');
      nav.removeAttribute('aria-hidden');
      document.body.classList.add('nav-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      var first = nav.querySelector('a,button');
      if (first) first.focus();
    }
    function close() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('nav-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (lastFocus) lastFocus.focus();
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mnav-open]')) { e.preventDefault(); open(); }
      else if (e.target.closest('[data-mnav-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
    });
  }

  /* ---------------- product gallery ---------------- */
  function galleries() {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-gallery-main] img');
      var thumbs = g.querySelectorAll('[data-gallery-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var full = t.getAttribute('data-full');
          if (!full) return;
          main.setAttribute('src', full);
          main.removeAttribute('srcset');
          if (t.getAttribute('data-alt')) main.setAttribute('alt', t.getAttribute('data-alt'));
          thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
        });
      });
    });
  }

  /* ---------------- sticky buy bar ---------------- */
  function stickyBar() {
    var bar = document.querySelector('[data-sticky-buy]');
    var anchor = document.querySelector('[data-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    }, { rootMargin: '0px 0px -100% 0px', threshold: 0 });
    io.observe(anchor);
  }

  /* ---------------- parallax ---------------- */
  function parallax() {
    if (reduceMotion) return;
    var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (!nodes.length || !('IntersectionObserver' in window)) return;
    var active = [];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { if (active.indexOf(en.target) < 0) active.push(en.target); }
        else { active = active.filter(function (n) { return n !== en.target; }); }
      });
    }, { threshold: 0 });
    nodes.forEach(function (n) { io.observe(n); });
    var ticking = false;
    function frame() {
      ticking = false;
      var vh = window.innerHeight;
      active.forEach(function (n) {
        var amt = parseFloat(n.getAttribute('data-parallax')) || 12;
        var rect = n.getBoundingClientRect();
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh; // -1..1
        n.style.transform = 'translate3d(0,' + (-progress * amt).toFixed(2) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(frame); }
    }, { passive: true });
    frame();
  }

  /* ---------------- reveal on scroll ---------------- */
  function reveals() {
    var nodes = document.querySelectorAll('.reveal');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  function boot() {
    Drawer.init();
    header();
    mobileNav();
    galleries();
    stickyBar();
    parallax();
    reveals();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function () {
    galleries(); stickyBar(); parallax(); reveals();
  });
})();

/* ============================================================
   BRUUT FINAL sliders
   Important: mobile lifestyle navigation uses scrollLeft only.
   It never calls scrollIntoView, so it cannot move the page vertically.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initBruutSlider(root) {
    if (!root || root.dataset.bruutSliderReady === '1') return;
    root.dataset.bruutSliderReady = '1';

    var track = root.querySelector('[data-slider-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slider-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slider-dot]'));
    var prev = root.querySelector('[data-slider-prev]');
    var next = root.querySelector('[data-slider-next]');
    var pause = root.querySelector('[data-slider-pause]');
    var pauseIcon = root.querySelector('[data-slider-pause-icon]');
    if (!track || slides.length < 2) return;

    var kind = root.dataset.sliderKind || '';
    var interval = parseInt(root.dataset.autoplay || '0', 10) || 0;
    var index = 0;
    var timer = null;
    var userPaused = false;
    var pointerStartX = null;
    var scrollTimer = null;

    function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }

    function setVideoState() {
      slides.forEach(function (slide, i) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (kind === 'cinema' && i === index && document.visibilityState === 'visible' && !reduceMotion) {
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function lifestyleLeft(i) {
      var slide = slides[i];
      if (!slide) return 0;
      var trackRect = track.getBoundingClientRect();
      var slideRect = slide.getBoundingClientRect();
      return track.scrollLeft + (slideRect.left - trackRect.left) - ((track.clientWidth - slide.offsetWidth) / 2);
    }

    function render(opts) {
      opts = opts || {};
      if (kind === 'cinema') {
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      } else if (kind === 'lifestyle') {
        if (isMobile()) {
          var left = lifestyleLeft(index);
          track.scrollTo({ left: Math.max(0, left), behavior: opts.instant ? 'auto' : 'smooth' });
        } else {
          var desktopLeft = slides[index].offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || '0');
          var maxLeft = Math.max(0, track.scrollWidth - track.clientWidth);
          desktopLeft = Math.max(0, Math.min(desktopLeft, maxLeft));
          track.style.transform = 'translate3d(' + (-desktopLeft) + 'px,0,0)';
        }
      }
      updateDots();
      setVideoState();
    }

    function go(to, userInitiated) {
      index = (to + slides.length) % slides.length;
      render();
      if (userInitiated) restart();
    }

    function canAutoplay() {
      if (userPaused || reduceMotion || interval <= 0 || document.visibilityState !== 'visible') return false;
      /* On touch/mobile the lifestyle rail is user-driven: no surprise movement. */
      if (kind === 'lifestyle' && isMobile()) return false;
      return true;
    }

    function restart() {
      window.clearInterval(timer);
      timer = null;
      if (canAutoplay()) {
        timer = window.setInterval(function () { go(index + 1, false); }, interval);
      }
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1, true); });
    if (next) next.addEventListener('click', function () { go(index + 1, true); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { index = i; render(); restart(); });
    });

    if (pause) {
      pause.addEventListener('click', function () {
        userPaused = !userPaused;
        pause.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pause.setAttribute('aria-label', userPaused ? 'Start slider' : 'Pauzeer slider');
        if (pauseIcon) pauseIcon.textContent = userPaused ? '▶' : 'Ⅱ';
        restart();
      });
    }

    if (kind === 'cinema') {
      root.addEventListener('pointerdown', function (e) {
        if (e.target.closest('button,a')) return;
        pointerStartX = e.clientX;
      }, { passive: true });
      root.addEventListener('pointerup', function (e) {
        if (pointerStartX === null) return;
        var dx = e.clientX - pointerStartX;
        pointerStartX = null;
        if (Math.abs(dx) > 45) go(index + (dx < 0 ? 1 : -1), true);
      }, { passive: true });
    }

    if (kind === 'lifestyle') {
      track.addEventListener('scroll', function () {
        if (!isMobile()) return;
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          var center = track.scrollLeft + track.clientWidth / 2;
          var nearest = 0;
          var distance = Infinity;
          slides.forEach(function (slide, i) {
            var d = Math.abs((slide.offsetLeft + slide.offsetWidth / 2) - center);
            if (d < distance) { distance = d; nearest = i; }
          });
          index = nearest;
          updateDots();
        }, 100);
      }, { passive: true });
    }

    root.addEventListener('mouseenter', function () { window.clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    root.addEventListener('focusin', function () { window.clearInterval(timer); });
    root.addEventListener('focusout', restart);

    document.addEventListener('visibilitychange', function () {
      setVideoState();
      restart();
    });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        render({ instant: true });
        restart();
      }, 120);
    }, { passive: true });

    render({ instant: true });
    restart();
  }

  function bootBruutSliders(scope) {
    (scope || document).querySelectorAll('[data-bruut-slider]').forEach(initBruutSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootBruutSliders(document); });
  } else {
    bootBruutSliders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootBruutSliders(event.target || document);
  });
})();
